module.exports = __webpack_public_path__ + "author_default-0679d81b0427e2f14051.svg";